<script>
export default {
  name: 'AccessDeniedError'
}
</script>

<template>
<div class="error access-denied">
  <p>Access denied</p>
</div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/errors/AccessDeniedError.vue